// Single route policy shared by route records and sidebar items (including composite menu names).
export const ACCOUNT_ROUTE_PERMISSIONS = Object.freeze({
  BuyerDashboard: 'call_logs',
  BuyerCallLogs: 'call_logs',
  SellerCallLogs: 'call_logs',
  Campaigns: 'campaigns',
  BuyerChannelBidding: 'campaigns',
  BuyerCreateCampaign: 'campaigns',
  BuyerCreateSoftphoneCampaign: 'campaigns',
  ListBuyerCampaigns: 'campaigns',
  BuyerEditCampaign: 'campaigns',
  BuyerEditSoftphoneCampaign: 'campaigns',
  ResumeBuyerCampaignFromEmail: 'campaigns',
  SellerDashboard: 'campaigns',
  SellerAvailableOffers: 'campaigns',
  SellerOfferRTTRequest: 'campaigns',
  ListRingTreeTargetRequests: 'campaigns',
  SellerCreatives: 'campaigns',
  UploadCreative: 'campaigns',
  ReviewCreatives: 'campaigns',
  BlockedChannels: 'campaigns',
  RingbaIntegration: 'admin',
  RingbaIntegrationOnboarding: 'admin',
  BuyerAccountBudget: 'billing',
  BuyerCampaignSettings: 'campaigns',
  AccountTimezone: 'campaigns',
  BillingSettings: 'billing',
  BankInfo: 'billing',
  OnboardingBuyer: 'admin',
  OnboardingSeller: 'admin',
  UserManagement: 'admin',
  ListApiTokens: 'admin',
  CreateApiToken: 'admin'
})

export function applyAccountRoutePermissions(routes) {
  routes.forEach(route => {
    const permission = ACCOUNT_ROUTE_PERMISSIONS[route.name]
    if (permission) route.meta = { ...route.meta, permission }
    if (route.children) applyAccountRoutePermissions(route.children)
  })
}

export function isAccountMenuAllowed(name, hasPermission) {
  return !name || name.split('|').some(route =>
    !ACCOUNT_ROUTE_PERMISSIONS[route] || hasPermission(ACCOUNT_ROUTE_PERMISSIONS[route]))
}
